export default __webpack_public_path__ + "static/media/like.1477614b.png";